/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AppId } from "../../commons/types/AppId";
export const AccountPatch = core.serialization.object({
    name: core.serialization.string().optional(),
    defaultAppId: AppId.optional(),
});
